/**
 * @generated SignedSource<<81ea8609eb75f31e90b5849032b07215>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarTeamEventEditScreenComponent_storeCalendars$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditComponent_storeCalendars">;
  readonly " $fragmentType": "CalendarTeamEventEditScreenComponent_storeCalendars";
}>;
export type CalendarTeamEventEditScreenComponent_storeCalendars$key = ReadonlyArray<{
  readonly " $data"?: CalendarTeamEventEditScreenComponent_storeCalendars$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditScreenComponent_storeCalendars">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CalendarTeamEventEditScreenComponent_storeCalendars",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CalendarTeamEventEditComponent_storeCalendars"
    }
  ],
  "type": "StoreCalendar",
  "abstractKey": null
};

(node as any).hash = "9506973005301455d280649ba209f575";

export default node;
